import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Navigate from './Routing';


function App() {

    return (
    <>
     <Navigate/>
      </>
 
  );
}

export default App;




